// extracted by mini-css-extract-plugin
export default {"history":"Expenses_history__-tkSX","head":"Expenses_head__7LUPg","list":"Expenses_list__k7UYN"};